import React from 'react';
import { WithIcon } from './WithIcon';

export const IconGallery = WithIcon(
  'Gallery',
  '-2 -1.333 24 20',
  <path d="M 16.667 4.333 L 16.667 17 L 0 17 L 0 4.333 L 16.667 4.333 Z M 20 0.333 L 20 13 L 18.773 13 L 18.773 1.6 L 3.333 1.6 L 3.333 0.334 L 20 0.334 L 20 0.333 Z" />
);
